module.exports = __webpack_public_path__ + "img/flow-step-1.0f61fb8.png";